require('./tabDropdown.scss');
const PropTypes = require('prop-types');
const React = require('react');
const {
    Component
} = require('react');
const className = require('classnames');

const { Dropdown } = require('commonsComponents/dropdown');
const { DropdownLang } = require('components/commons/tabs/tabDropdown/dropdownLang');

// @utilities
const has = require('lodash/object/has');

class TabDropdown extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isDropdownOpen: false
        }

        this.onDropdownChangeState = this.onDropdownChangeState.bind(this);
    }

    onDropdownChangeState(callbackState) {
        if (callbackState.open !== undefined) {
            this.setState({
                isDropdownOpen: callbackState.open
            });
        }
    }

    render() {
        const { label, isSelected, customClassName, onClick, locator, dropdown, onClickItem } = this.props;

        const classNamesLabel = className('ok-tab__label', {
            'is-selected': isSelected,
            'ok-tab__label--open': this.state.isDropdownOpen
        });

        const classNamesMarker = className('ok-tab__marker', {
            'is-selected': isSelected
        });

        const classNameComponent = className('ok-tab', {
            [customClassName]: !!customClassName
        });

        const locatorName = `btn${locator}`;

        const onDropdownChangeState = this.onDropdownChangeState;

        const isTabLang = __CONTACT_CENTER__ && has(dropdown[0], ['hreflang']);

        const DropdownComponent = isTabLang ? DropdownLang : Dropdown;

        return (
            <li className={classNameComponent} onClick={onClick}>
                {<DropdownComponent
                    className={classNameComponent}
                    buttonClass="ok-tab__link ok-tab__button"
                    items={dropdown}
                    id={locatorName}
                    onClickItem={(!isTabLang ? onClickItem : undefined)}
                    withArrow={false}
                    onStateChange={onDropdownChangeState}
                >
                    <span className={classNamesLabel}>
                        {label}
                    </span>
                    <hr className={classNamesMarker} />
                </DropdownComponent>}
            </li>
        );
    }
}

TabDropdown.propTypes = {
    customClassName: PropTypes.string,
    isSelected: PropTypes.bool,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    locator: PropTypes.string,
    onClick: PropTypes.func,
    dropdown: PropTypes.array,
    path: PropTypes.string,
    onClickItem: PropTypes.func

};

TabDropdown.defaultProps = {
    isSelected: false
};

module.exports = TabDropdown;
